import type { ReactNode } from 'react';

/** A need-row value shown once for its SO lines; edits stay on the SO rows. */
export function NeedReadOnly({ children }: { children: ReactNode }) {
  return (
    <span inert className="pointer-events-none contents">
      {children}
    </span>
  );
}
